import { createContext } from "react"

const SessionContext = createContext({
    studentGuid: "",
    oAuthToken: ""
})

export default SessionContext